import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import uniqid from 'uniqid';

import { CONTENT_TYPES } from './content-types.constants';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

interface RelatedContentItemAttributes {
  name?: string;
  contentIs?: string;
}

interface RelatedContentItem {
  id: string | number;
  attributes?: RelatedContentItemAttributes;
}

interface RelatedContentProps {
  content?: RelatedContentItem[];
}

const RelatedContent = ({
  content = [],
}: RelatedContentProps): React.JSX.Element => {
  const getIcon = (contentType?: string): React.ReactNode => {
    const item = CONTENT_TYPES.find(({ type }) => type === contentType);

    return item?.icon;
  };

  return (
    <Box
      sx={{
        '@media (min-width: 375px)': { mb: 3 },
        '@media (min-width: 960px)': { mb: 4 },
      }}
    >
      <h2 className="font-semibold text-xl">Related content</h2>
      {content.map(({ id, attributes = {} }) => {
        const { name, contentIs } = attributes;

        return (
          <Box key={uniqid()} sx={{ mt: 1.5 }}>
            <RouterLink
              to={`/learn/content/${(
                contentIs as string
              ).toLowerCase()}s/${id}`}
              className="text-blue-700 hover:text-navy-800 font-medium text-lg transition"
            >
              {name}
            </RouterLink>
            <Stack
              direction="row"
              sx={{
                alignItems: 'center',
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                color: 'tokens.gray.600',
              }}
            >
              <Stack direction="row" sx={{ alignItems: 'center' }}>
                {getIcon(contentIs)}
              </Stack>
              <Box sx={{ ml: 1, fontSize: '0.875rem', lineHeight: '1.25rem' }}>
                {contentIs}
              </Box>
            </Stack>
          </Box>
        );
      })}
    </Box>
  );
};

export default RelatedContent;
